<template>
  <div style="display: inline-block;">
    <el-form-item class="formitem" v-if="prop!=''" :prop="prop">
      <slot></slot>
    </el-form-item>
    <slot v-else></slot>
  </div>
</template>

<script>
    export default {
        name: "index",
        props:{
            prop:{
                type:String,
                default:''
            }
        }
    }
</script>

<style scoped lang="scss">
  .formitem{
    margin-left: 0!important;
    /deep/{
      .el-form-item__content{
        margin-left: 0!important;
        font-size: 0;
        line-height: 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// UI/AlFormItem/index.vue